module.exports = __webpack_public_path__ + "static/media/mariam.dce96926.png";